import React from "react";
import "./index.scss";

const ChartTable = ({ headers, rows }) => {
  // Dynamically generate the `grid-template-columns` based on the number of columns
  const gridTemplateColumns = headers.map(() => "minmax(100px, 1fr)").join(" ");

  return (
    <div className="chart-custom-table">
      {/* Scrollable Container */}
      <div className="table-container">
        {/* Table Header */}
        <div className="table-row table-header" style={{ gridTemplateColumns }}>
          {headers.map((header, index) => (
            <div key={index} className="header-cell" title={header}>
              {header}
            </div>
          ))}
        </div>
        {/* Table Rows */}
        <div className="table-body">
          {rows.map((row, rowIndex) => (
            <div
              className="table-row"
              style={{ gridTemplateColumns }}
              key={rowIndex}
            >
              {row.map((cell, cellIndex) => (
                <div key={cellIndex} title={cell}>
                  {cell}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChartTable;
